<template lang="pug">
div
    button.change-button(
      :disabled="disabled || loading"
      @click="show = true"
      v-if="showButton"
      @hide="hideModal()"
      data-testid="action-btn-ingresar-reparacion"
    )
      b-spinner(v-if="loading" small)
      span {{ loading ? 'Procesando...' : 'Ingresar Reparación' }}
    SamtekModal(
      v-model="show"  
      size="lg" 
      title="Ingresar Reparación"
      confirmText="Aceptar"
      cancelText="Cancelar"
      :loading="loading"
      confirmTestId="modal-accept-reparacion-1"
      @shown="onModalShown"
      @hide="onModalHide"
      @confirm="showMessageModal"
      @cancel="hideModal"
    )
      h6.label Diagnóstico
      p {{ ot.diagnostico_detail && ot.diagnostico_detail.informe }}
      b-form-group(
        label-for="input-informe"
        label="Solución"
      )
        b-form-textarea(
          id="input-informe"
          rows="5"
          v-model="form.solucion"
          placeholder="Registrar la solución (obligatorio)"
          data-testid="input-solucion"
          :state="$v.form.solucion.$dirty ? !$v.form.solucion.$invalid : null")
        .errors(v-if="$v.form.solucion.$dirty")
          b-form-invalid-feedback(:state="$v.form.solucion.required")
            | Campo requerido
      hr
      b-col
        OTUploads(:ot="ot" fileNamePattern="evidencia-reparacion" :attachmentType="ARCHIVO_ADJUNTO_TIPO.EVIDENCIA")
      hr
    SamtekModal(
      v-model="showConfirm"
      title="Información"
      confirmText="Aceptar"
      cancelText="Cancelar"
      @confirm="handleConfirm"
      @cancel="cancel"
    )
      p {{ message }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { ARCHIVO_ADJUNTO_TIPO } from '@/utils/enums'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'
import OTUploads from '../OTUploads.vue'

export default {
  components: {
    OTUploads,
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  name: 'ActionIngresarReparacion',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],

  validations: {
    form: {
      solucion: { required },
    },
  },
  data() {
    return {
      show: false,
      form: {
        solucion: null,
        id: null,
        ot: this.ot ? this.ot.ot : null,
      },
      message: null,
      showConfirm: false,
    }
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
    ...mapGetters('OTStore', ['statusRequest']),
    ARCHIVO_ADJUNTO_TIPO: () => ARCHIVO_ADJUNTO_TIPO,
    showButton() {
      const estadosParteOk = ['Dropped', 'Usado', 'Part failed', 'Cancelado'].map(
        (s) => s.toLowerCase()
      )
      const partesPendientes =
        this.ot.solicitud_partes?.filter(
          (parte) => estadosParteOk.indexOf(parte.estado.toLowerCase()) === -1
        ) || []
      return partesPendientes.length === 0
    },
  },
  watch: {
    ot() {
      if (this.ot.diagnostico_detail) {
        this.form.informe = this.ot.diagnostico_detail?.informe
        this.form.solucion = this.ot.diagnostico_detail?.solucion || null
        this.form.id = this.ot.diagnostico_detail.id
        this.form.ot = this.ot.ot
        this.form.tecnico_reparacion = this.ot.tecnico_asignado
      }
    },
  },
  methods: {
    ...mapActions('Diagnosticos', ['updateDiagnoseOT']),
    ...mapActions('OTStore', ['getOT']),
    ...mapActions('Warehouse', ['changeWarehouseState']),

    onModalShown() {
      // Evento cuando se muestra el modal
    },

    onModalHide() {
      // Evento cuando se oculta el modal
    },

    hideModal() {
      this.show = false
    },
    async showMessageModal() {
      if (this.$v.$invalid) {
        this.$bvToast.toast('Complete todo los campos requeridos', {
          variant: 'danger',
        })
        this.$v.$touch()
      } else {
        this.message = null
        const repuestos_usados =
          this.ot.solicitud_partes?.filter(
            (parte) => parte.estado === 'Usado'
          ) || []

        if (repuestos_usados.length > 0) {
          this.message =
            'Se utilizaron repuestos. Al aceptar, la reparación quedará pendiente de revisión por un supervisor.'
        } else if (this.ot.diagnostico_detail.replicar_falla === true) {
          this.message =
            'No se utilizaron repuestos y la falla fue replicada. Al aceptar, la reparación quedará pendiente de revisión por un supervisor.'
        } else if (this.ot.diagnostico_detail.replicar_falla === false) {
          this.message =
            'No se utilizaron repuestos y la falla no fue replicada. Al aceptar, la reparación quedará pendiente de revisión por un supervisor.'
        } else {
          this.message =
            'Al aceptar, la reparación quedará pendiente de revisión por un supervisor.'
        }

        this.showConfirm = true
      }
    },
    async handleConfirm() {
      try {
        await this.executeWithLoading(async () => {
          this.show = false
          await this.changeWarehouseState({
            state: 'Reparado por revisar',
            orden: this.ot.ot,
            user: this.user.user.id,
          })
          await this.saveDiagnostic()
          this.message = null
          this.showConfirm = false
        })
      } catch (error) {
        console.error('Error en confirmación:', error)
        this.$bvToast.toast('Error al procesar la reparación', {
          variant: 'danger',
        })
      }
    },
    async saveDiagnostic() {
      this.form.id = this.ot.diagnostico_detail
        ? this.ot.diagnostico_detail.id
        : this.ot.diagnostico
      this.form.tecnico_reparacion = this.ot.tecnico_asignado.id
      const response = await this.updateDiagnoseOT(this.form)
      if (response.status === 200) {
        console.log('Diagnóstico actualizado', response.data)
        const message = response.data.message || 'Solución guardada.'
        this.$bvToast.toast(message, {
          variant: 'success',
        })
        this.$emit('changed')
      } else {
        this.$bvToast.toast(`Error al guardar reparación: ${response.data}`, {
          variant: 'danger',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.preview,
.capture {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
img {
  width: 100%;
}
.webcam {
  display: inline-flex;
  justify-content: space-between;
  margin: -8pxl;
}

.label {
  color: #74788d;
  font-weight: bold;
}
</style>
